import React, { useContext, useEffect, useState } from "react";
import { Content } from "antd/es/layout/layout";
import {
  CaretDownFilled,
  CaretUpFilled,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { REGION_GROUP ,DATA_MASTER_DATA_TYPE} from "../../../../lib/const";
import useMasterData from "../../../../lib/hooks/useMasterData";
import useCountry from "../../../../lib/hooks/useCountry";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../routes";
import {
  SearchCustomerCompetitorContext,
  initialPageValues,
  initialSearchValues,
} from "../searchContext";

const { Title } = Typography;
const { Option } = Select;

const Search =(values)=>{
  const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
  const [countries, optionCountries] = useCountry();

  
  const {
    region,
    header,
  } = values;

  const {
      setPageValues,
      setSearch,
      searchValues,
      pageValues,
      setSearchValues,
    } = useContext(SearchCustomerCompetitorContext);
    let customerGroupByRegions = [];

    const handleClearSearchForm = () => {
        form.resetFields();
        setSearchValues({
      ...initialSearchValues,
      competitorType: region,
      customerGroupByRegion: regionGroup.map((item) => customerGroupByRegions.push(item.dataId)),
    });
    setPageValues(initialPageValues);
    setSearch(true);
  };
  const onSearch = async (values) => {
    if (
      values?.customerGroupByRegion &&
      values?.customerGroupByRegion.includes("all")
    ) {
      regionGroup.map((item) => customerGroupByRegions.push(item.dataId));
    }else if (!values?.customerGroupByRegion){
      regionGroup.map((item) => customerGroupByRegions.push(item.dataId));

    }
     else {
      customerGroupByRegions = values?.customerGroupByRegion;
    }
    setSearch(true);
    setSearchValues({
      factoryName : values?.factoryName,
      countryId: values?.countryId || [],
      customerGroupByRegion: customerGroupByRegions ,
      competitorType: region,
    })
    setPageValues({
      page: 0,
      pageSize: pageValues.pageSize,
      total: pageValues.total,
      totalPage: pageValues.totalPage,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    });
  }
  const [form] = Form.useForm();
  const navigate = useNavigate();
    return (
        <Content>
          <Form style={{ marginBottom: 20 }}>
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <div className="flex justify-between items-center">
                    <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                      {header}
                    </Title>
                    <div>
                      <Space>
                        {/* {(roleUser[0]?.isAll || roleUser[0]?.isExport) && (
                          <Button
                            onClick={() => onExport("ข้อมูลลูกค้าปัจจุบัน.xlsx")}
                          >
                            <UploadOutlined /> Export Excel
                          </Button>
                        )} */}
                        {/* {(roleUser[0]?.isAll || roleUser[0]?.isCreate) && ( */}
                          <Button
                            type="primary"
                            onClick={() => 
                              navigate(
                              region === "domestic" ? 
                              routes.add_customer_domestic_competitor : 
                              routes.add_customer_international_competitor, 
                              {
                                state: {
                                    id: 1,
                                    action_type: "CREATE",
                                },
                              }
                            )
                          }
                          >
                            <PlusOutlined /> เพิ่มข้อมูล
                          </Button>
                      {/* )} */}
                      </Space>
                    </div>
                  </div>
                </Col>
              </Row>
          </Form>
          <Form
            layout={"vertical"}
            form={form}
            style={{
              padding: 20,
              backgroundColor: "#fff",
              borderRadius: "12px",
              border: "1px solid #F2F2F2",
              boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`,
            }}
            onFinish={(value) =>
              onSearch({
                ...value,
              })
            }
          >
            <Row gutter={[24, 16]}>
              <Col className="gutter-row" span={8}>
                <Form.Item name="factoryName">
                  <AutoComplete
                    filterOption={true}
                    // options={factoryAutocomplete}
                    // onSearch={(text) => getListFactoryAutocomplete(text)}
                  >
                    <Input placeholder="ชื่อบริษัท" prefix={<SearchOutlined />} />
                  </AutoComplete>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item name="countryId">
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="สัญชาติคู่แข่ง"
                    style={{
                      width: "100%",
                    }}
                    mode={"multiple"}
                    maxTagCount={"responsive"}
                    options={optionCountries}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item name={"customerGroupByRegion"}>
                  <Select
                    allowClear
                    placeholder="กลุ่มคู่แข่งตามสัญชาติ"
                    style={{
                      width: "100%",
                    }}
                    mode={"multiple"}
                    maxTagCount={"responsive"}
                  >
                    <Option key={"all"} value={"all"}>
                      เลือกทั้งหมด
                    </Option>
                    {regionGroup.map((item) => (
                      <Option value={item.dataId}>{item.dataDetailTh}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24} align="right">
                <Space>
                  <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
                  <Button type="primary" htmlType="submit">
                    ค้นหา
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Content>
    );
};

export default Search;